function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/dropdown/button/splitbuttonview
 */
import View from '../../view';
import ButtonView from '../../button/buttonview';
import KeystrokeHandler from '@ckeditor/ckeditor5-utils/src/keystrokehandler';
import FocusTracker from '@ckeditor/ckeditor5-utils/src/focustracker';
import dropdownArrowIcon from '../../../theme/icons/dropdown-arrow.svg';
import '../../../theme/components/dropdown/splitbutton.css';
/**
 * The split button view class.
 *
 *		const view = new SplitButtonView();
 *
 *		view.set( {
 *			label: 'A button',
 *			keystroke: 'Ctrl+B',
 *			tooltip: true
 *		} );
 *
 *		view.render();
 *
 *		document.body.append( view.element );
 *
 * Also see the {@link module:ui/dropdown/utils~createDropdown `createDropdown()` util}.
 *
 * @implements module:ui/dropdown/button/dropdownbutton~DropdownButton
 * @extends module:ui/view~View
 */

var SplitButtonView = /*#__PURE__*/function (_View) {
  _inherits(SplitButtonView, _View);

  var _super = _createSuper(SplitButtonView);

  /**
   * @inheritDoc
   */
  function SplitButtonView(locale) {
    var _this;

    _classCallCheck(this, SplitButtonView);

    _this = _super.call(this, locale);
    var bind = _this.bindTemplate; // Implement the Button interface.

    _this.set('class');

    _this.set('icon');

    _this.set('isEnabled', true);

    _this.set('isOn', false);

    _this.set('isToggleable', false);

    _this.set('isVisible', true);

    _this.set('keystroke');

    _this.set('label');

    _this.set('tabindex', -1);

    _this.set('tooltip');

    _this.set('tooltipPosition', 's');

    _this.set('type', 'button');

    _this.set('withText', false);
    /**
     * Collection of the child views inside of the split button {@link #element}.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */


    _this.children = _this.createCollection();
    /**
     * A main button of split button.
     *
     * @readonly
     * @member {module:ui/button/buttonview~ButtonView}
     */

    _this.actionView = _this._createActionView();
    /**
     * A secondary button of split button that opens dropdown.
     *
     * @readonly
     * @member {module:ui/button/buttonview~ButtonView}
     */

    _this.arrowView = _this._createArrowView();
    /**
     * Instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}. It manages
     * keystrokes of the split button:
     *
     * * <kbd>▶</kbd> moves focus to arrow view when action view is focused,
     * * <kbd>◀</kbd> moves focus to action view when arrow view is focused.
     *
     * @readonly
     * @member {module:utils/keystrokehandler~KeystrokeHandler}
     */

    _this.keystrokes = new KeystrokeHandler();
    /**
     * Tracks information about DOM focus in the dropdown.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker}
     */

    _this.focusTracker = new FocusTracker();

    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-splitbutton', bind.to('class'), bind.if('isVisible', 'ck-hidden', function (value) {
          return !value;
        }), _this.arrowView.bindTemplate.if('isOn', 'ck-splitbutton_open')]
      },
      children: _this.children
    });

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SplitButtonView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      _get(_getPrototypeOf(SplitButtonView.prototype), "render", this).call(this);

      this.children.add(this.actionView);
      this.children.add(this.arrowView);
      this.focusTracker.add(this.actionView.element);
      this.focusTracker.add(this.arrowView.element);
      this.keystrokes.listenTo(this.element); // Overrides toolbar focus cycling behavior.

      this.keystrokes.set('arrowright', function (evt, cancel) {
        if (_this2.focusTracker.focusedElement === _this2.actionView.element) {
          _this2.arrowView.focus();

          cancel();
        }
      }); // Overrides toolbar focus cycling behavior.

      this.keystrokes.set('arrowleft', function (evt, cancel) {
        if (_this2.focusTracker.focusedElement === _this2.arrowView.element) {
          _this2.actionView.focus();

          cancel();
        }
      });
    }
    /**
     * Focuses the {@link #actionView#element} of the action part of split button.
     */

  }, {
    key: "focus",
    value: function focus() {
      this.actionView.focus();
    }
    /**
     * Creates a {@link module:ui/button/buttonview~ButtonView} instance as {@link #actionView} and binds it with main split button
     * attributes.
     *
     * @private
     * @returns {module:ui/button/buttonview~ButtonView}
     */

  }, {
    key: "_createActionView",
    value: function _createActionView() {
      var actionView = new ButtonView();
      actionView.bind('icon', 'isEnabled', 'isOn', 'isToggleable', 'keystroke', 'label', 'tabindex', 'tooltip', 'tooltipPosition', 'type', 'withText').to(this);
      actionView.extendTemplate({
        attributes: {
          class: 'ck-splitbutton__action'
        }
      });
      actionView.delegate('execute').to(this);
      return actionView;
    }
    /**
     * Creates a {@link module:ui/button/buttonview~ButtonView} instance as {@link #arrowView} and binds it with main split button
     * attributes.
     *
     * @private
     * @returns {module:ui/button/buttonview~ButtonView}
     */

  }, {
    key: "_createArrowView",
    value: function _createArrowView() {
      var arrowView = new ButtonView();
      var bind = arrowView.bindTemplate;
      arrowView.icon = dropdownArrowIcon;
      arrowView.extendTemplate({
        attributes: {
          class: 'ck-splitbutton__arrow',
          'aria-haspopup': true,
          'aria-expanded': bind.to('isOn', function (value) {
            return String(value);
          })
        }
      });
      arrowView.bind('isEnabled').to(this);
      arrowView.delegate('execute').to(this, 'open');
      return arrowView;
    }
  }]);

  return SplitButtonView;
}(View);

export { SplitButtonView as default };